import LanguageSelector from "../../../../i18n/LanguageSelector";
import {LogoComponent} from "../LogoComponent";

import NavLinkWithLocation from "../NavLinkWithLocation";
import MenuComponent from "../MenuComponent/MenuComponent";
import React from "react";
import "./PageHeader.css";
import {AmplitudeEvent, logEvent} from "../../../../utils/amplitude";

export const PageHeader = () => {
  const navLinks = [
    { to: "/games", textPath: "title.games" },
    //{ to: "/history", textPath: "title.history" },
  ];

  const navLinkClick = (to:string) => () => {
    logEvent(AmplitudeEvent.NAVIGATION_CLICK, {type: "desktop", to});
  };

  return (
    <header className="page-header">
      <div className="container">
        <div className="links">
          <LogoComponent />
          {navLinks.map(({ to, textPath }) => (
              <NavLinkWithLocation key={to} className="desktop" to={to} textPath={textPath} onClick={navLinkClick(to)} />
          ))}
        </div>
        <LanguageSelector className="desktop"/>
        <MenuComponent />
      </div>
    </header>
  );
};
